import { TableColumn } from "element-ui";

/**
 * props:{ title, label, width}
 */
const ColumnsFactory = args => {
  return <TableColumn {...args}></TableColumn>;
};

export default ColumnsFactory;
